/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowaskstyle3Inputs */

const en_aiflowaskstyle3 = /** @type {(inputs: Aiflowaskstyle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which style fits?`)
};

const de_aiflowaskstyle3 = /** @type {(inputs: Aiflowaskstyle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcher Stil passt?`)
};

/**
* | output |
* | --- |
* | "Which style fits?" |
*
* @param {Aiflowaskstyle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowaskstyle3 = /** @type {((inputs?: Aiflowaskstyle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowaskstyle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowaskstyle3(inputs)
	return de_aiflowaskstyle3(inputs)
});
export { aiflowaskstyle3 as "aiFlowAskStyle" }